<template>
  <div>
    <header-mx></header-mx>
    <section class="main">
      <div class="figuras">
        <div class="container">
          <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
            <div class="col-sm-6 offset-sm-3">
              <div class="azuloscuro row">
                <div class="col-12 text-center">
                  <h1>Servicios académicos</h1>
                </div>
              </div>
              <div class="row">
                <div class="formulario col-12 bggris rounded pt-5 pb-4 card">
                  <form method="post" @submit="submitFormulario($event)">
                    <label>
                      <input
                        type="text"
                        v-model="matricula"
                        maxlength="100"
                        placeholder="Matrícula"
                        required
                      />
                    </label>

                    <label class="m-0">
                      <input
                        type="password"
                        v-model="password"
                        maxlength="100"
                        placeholder="Contraseña"
                        required
                      />
                    </label>

                    <div class="text-center pt-2">
                      <button type="submit" class="submit btnblanco">Entrar</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span class="loadinghome" v-bind:class="{active: this.$store.state.loading}">
          <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
        </span>
      </div>

      <footer>
        <div class="container">
          <div class="row p-2">
            
            <div class="col-12 text-center">
              <div class="texto">
               
                <span class="mx-2">

                  <a target="_blank" href="https://www.iee.edu.mx/reglamento-general-de-estudiantes-iee">Reglamento General de Estudiantes IEE</a>
                </span>
              </div>
            </div>

            
            <div class="col-12 text-center">
              <div class="texto">
                <span class="px-1">© 2021 IEE Corporativo</span>

                <br class="d-block d-md-none" />
                <span class="d-none d-md-inline-block">|</span>
                <span class="mx-2">Todos los derechos reservados.</span>

               
              </div>
            </div>
            
          </div>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "",
      matricula: "",
      password: ""
    };
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    AOS.init();

    if (this.$store.state.user != null && this.$store.state.user.user_level != null && this.$store.state.user.user_level!= "") {
      var $url = "";
      switch(this.$store.state.user.user_level){
				case 1:
					$url = '/alumnos/calificaciones';
				break;
				case 2:
					$url = '/egresados/estatus';
				break;
				case 5:
					$url = '/docentes/asignaturas';
				break;
				case 7:
					$url = '/dashboard/alumnos';
				break;
      }
      
      this.$router.push($url);
    }
  },
  components: {
    "header-mx": Header
  },
  methods: {
    submitFormulario(e) {
      console.log("submit");
      var vm = this;
      e.preventDefault();

      const https = require("https");

      vm.$store.state.loading = true;

      var qData = {
        matricula: this.matricula,
        password: this.password
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log("enviando");
      //console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "home/login.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data"
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          }
        })
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            //console.log(response.data);
            var res = response.data;

            if (res.status == "ok") {
              //localStorage.setItem('user', res.user);
              this.$cookie.set("useriee", JSON.stringify(res.user), 1);
              vm.$store.state.user = this.$cookie.get("useriee");
              this.$router.push(res.url);
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error en el envío, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

